module.exports = __webpack_public_path__ + "26b4d86b02559b0f5a4fc4f6d6c2452e.jpg";